export default "__VITE_ASSET__kmgqH1NI__"